module.exports = __webpack_public_path__ + "img/sponser-4.cd9b17e6.png";